import { useState } from "react";
import Welcome from "./Welcome";
import { translate, kmsCookie, extractCookieDomain } from "@kaltura/mediaspace-shared-utils";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { liveStudioApplicationFeature } from "../analytics";

const COOKIE_NAME = "kms-live-studio-dont-show-welcome";

/**
 * Handles the display of the Welcome modal according to browser session cookies
 */
export function StudioWelcomeManager() {
    const sendButtonAnalytics = useButtonAnalytics();
    const [showWelcomeModal, setShowWelcomeModal] = useState(() => {
        // Check for the cookie value
        const dontShowWelcome = kmsCookie(COOKIE_NAME) === "true";
        return !dontShowWelcome;
    });

    const handleWelcomeClose = () => {
        sendButtonAnalytics(
            "Close Viewing as Studio modal",
            ButtonClickAnalyticsType.CLOSE,
            undefined,
            liveStudioApplicationFeature,
            "viewing as studio modal"
        );
        setShowWelcomeModal(false);
    };

    const handleDontShowAgainChange = (dontShowAgain: boolean) => {
        sendButtonAnalytics(
            (dontShowAgain ? "Don't " : "") + "show the Studio view modal",
            ButtonClickAnalyticsType.TOGGLE,
            undefined,
            liveStudioApplicationFeature,
            "viewing as studio modal"
        );
        // Set the cookie to expire after 1 year and be available across subdomains
        const domain = extractCookieDomain(window.location.hostname);
        kmsCookie(COOKIE_NAME, dontShowAgain.toString(), { domain: "." + domain, path: "/", expires: 365 * 24 });
    };

    return (
        <Welcome
            open={showWelcomeModal}
            onClose={handleWelcomeClose}
            onDontShowAgainChange={handleDontShowAgainChange}
            title={translate("Welcome to the Studio")}
            contentText={translate(
                "Prepare and manage your broadcast from here. To see the attendee experience, click the Attendee view button."
            )}
        />
    );
}

export default StudioWelcomeManager;
